import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

// Chave lida pelas telas para filtrar os dados (CNPJs separados por vírgula).
export const CHAVE_SELECAO_LOJAS = 'currentCnpj';

/**
 * Fonte única da seleção de lojas: o filtro do header e o campo "Credenciado" das telas
 * gravam aqui, e quem estiver aberto recebe a mudança na hora (header ⇄ tela).
 */
@Injectable({
    providedIn: 'root'
})
export class SelecaoLojasService {
    private readonly mudancas = new Subject<string[]>();

    /** Emite a nova seleção sempre que alguém a altera nesta aba ou em outra. */
    readonly mudancas$: Observable<string[]> = this.mudancas.asObservable();

    constructor() {
        // Outra aba mudou a seleção (o localStorage é compartilhado entre abas).
        window.addEventListener('storage', evento => {
            if (evento.key === CHAVE_SELECAO_LOJAS || evento.key === null) {
                this.mudancas.next(this.obter());
            }
        });
    }

    obter(): string[] {
        const salvo = localStorage.getItem(CHAVE_SELECAO_LOJAS);
        return salvo ? salvo.split(',').map(c => c.trim()).filter(Boolean) : [];
    }

    /** Aceita um CNPJ (selects de loja única) ou uma lista (selects múltiplos). */
    definir(cnpjs: string | string[] | null | undefined): void {
        const lista = (Array.isArray(cnpjs) ? cnpjs : (cnpjs ? [cnpjs] : []))
            .map(c => String(c).trim())
            .filter(Boolean);

        if (lista.join(',') === this.obter().join(',')) {
            return;
        }

        if (lista.length === 0) {
            localStorage.removeItem(CHAVE_SELECAO_LOJAS);
        } else {
            localStorage.setItem(CHAVE_SELECAO_LOJAS, lista.join(','));
        }
        this.mudancas.next(lista);
    }
}

// Busca do ng-select de credenciados: casa pelo nome fantasia ou pelo CNPJ (com ou sem máscara).
export const buscarCredenciado = (termo: string, credenciado: any): boolean => {
    const texto = (termo || '').toLowerCase().trim();
    // Só vira busca por CNPJ quando o termo não tem letra ("super 1" continua busca por nome).
    const digitos = /^[\d.\/\-\s]+$/.test(texto) ? texto.replace(/\D/g, '') : '';
    return String(credenciado?.nome_fantasia || '').toLowerCase().includes(texto)
        || (digitos !== '' && String(credenciado?.cnpj || '').replace(/\D/g, '').includes(digitos));
};
